import { useEffect, useState } from 'react';

import { QuestionAttachment } from '@types';
import { showAttachment } from '@features/homeworks/utils';
import parseFillInTheBlanksHtml from '@utils/parseFillInTheBlanks';

interface FillInTheBlanksProps {
  question: any;
  onInputChange: (answers: string[]) => void;
}

const FillInTheBlanks = ({ question, onInputChange }: FillInTheBlanksProps) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>([]);

  const handleInputChange = (value: string, index: number) => {
    const updatedAnswers = [...selectedAnswers];

    updatedAnswers[index] = value;

    setSelectedAnswers(updatedAnswers);
    onInputChange(updatedAnswers);
  };

  useEffect(() => {
    setSelectedAnswers([]);
  }, [question?.id]);

  return (
    <>
      <div className="mx-1 flex w-full flex-wrap">
        {question?.questionAttachments?.map((attachment: QuestionAttachment) =>
          showAttachment(attachment)
        )}
      </div>

      <div className="text-lg font-bold text-primary">
        {question?.title ?? 'Complete the text with correct answer'}
      </div>

      <div className="mb-12 mt-6 w-full text-lg font-semibold leading-10">
        {parseFillInTheBlanksHtml({
          content: question?.question ?? '',
          answers: selectedAnswers,
          onChange: handleInputChange
        })}
      </div>
    </>
  );
};

export default FillInTheBlanks;
